import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKey1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconKey1"><Path fillRule="evenodd" clipRule="evenodd" d="M1 12C1 8.68629 3.68629 6 7 6C9.00871 6 10.7858 6.98751 11.8738 8.5H20.9806L23.7806 12L20.9806 15.5H17.7639L16 14.618L14.2361 15.5H11.8738C10.7858 17.0125 9.00871 18 7 18C3.68629 18 1 15.3137 1 12ZM7 13.5C7.82843 13.5 8.5 12.8284 8.5 12C8.5 11.1716 7.82843 10.5 7 10.5C6.17157 10.5 5.5 11.1716 5.5 12C5.5 12.8284 6.17157 13.5 7 13.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKey1;
